module.exports = __webpack_public_path__ + "img/ms.84cec783.svg";